"use client";

import { useContext } from "react";

import { mixpanelContext } from "../lib/mixpanelContext";

export const useMixpanel = () => useContext(mixpanelContext);
